import {
	IconApps,
	IconArrowLeft,
	IconBuilding,
	IconCreditCard,
	IconHistory,
	IconLayoutGrid,
	IconUsers,
} from "@tabler/icons-react";
import { useNavigate, useRouterState } from "@tanstack/react-router";
import type { MenuProps } from "antd";
import { Menu } from "antd";
import { useRouteOrgSlug } from "@/common/artemis-operations/organization";

export function AdminNav({ onNavigate }: { onNavigate?: () => void }) {
	const navigate = useNavigate();
	const pathname = useRouterState({ select: (s) => s.location.pathname });
	const orgSlug = useRouteOrgSlug();

	// Keys are the concrete pathnames (slug included) so selectedKeys matches directly.
	const items: MenuProps["items"] = [
		{
			key: `/${orgSlug}/admin`,
			icon: <IconBuilding height="1.3em" />,
			label: "Organization",
		},
		{
			key: `/${orgSlug}/admin/workspaces`,
			icon: <IconLayoutGrid height="1.3em" />,
			label: "Workspaces",
		},
		{
			key: `/${orgSlug}/admin/apps`,
			icon: <IconApps height="1.3em" />,
			label: "Apps",
		},
		{
			key: `/${orgSlug}/admin/billing`,
			icon: <IconCreditCard height="1.3em" />,
			label: "Billing",
		},
		{
			key: `/${orgSlug}/admin/users`,
			icon: <IconUsers height="1.3em" />,
			label: "Users",
		},
		{
			key: `/${orgSlug}/admin/audit`,
			icon: <IconHistory height="1.3em" />,
			label: "Audit log",
		},
		{ type: "divider" as const },
		{
			key: "/",
			icon: <IconArrowLeft height="1.3em" />,
			label: "Back",
		},
	];

	return (
		<Menu
			mode="inline"
			inlineIndent={10}
			selectedKeys={[pathname]}
			onClick={({ key }) => {
				navigate({ to: key });
				onNavigate?.();
			}}
			style={{ height: "100%" }}
			items={items}
		/>
	);
}
